import {Tag} from 'letrus-ui';
import {SimplifiedFeedbackData} from '../../types';
import {
  getSimplifiedFeedbackComment,
  SimplifiedFeedbackCriterion,
  SimplifiedFeedbackSeal,
} from '../../simplifiedFeedbackComments';
import styles from './FeedbackCommentCards.module.scss';

const CRITERIA_ORDER: SimplifiedFeedbackCriterion[] = ['c2', 'c4', 'c6'];

// Literal emoji, not FontAwesome — confirmed in the real HTML of the Lovable prototype
// (../../../../../tarefas/devolutiva-simplificada-quinto-ano/lovable-page-source.html):
// <span style="font-family:'Apple Color Emoji',...">🎯</span>. It sits outside the tag (a
// sibling of the whole block), not paired with it.
const CRITERION_EMOJI: Record<SimplifiedFeedbackCriterion, string> = {
  c2: '🎯', // Subject / adherence to the prompt
  c4: '🧩', // Format / development of the discursive genre
  c6: '💡', // Ideas / coherence
};

const SEAL_TAG_PROPS: Record<
  SimplifiedFeedbackSeal,
  {text: string; mainColor: string; backgroundColor: string}
> = {
  mandou_bem: {
    text: 'Mandou bem',
    mainColor: '#2fac66', // $secondary-green
    backgroundColor: '#c6f1d3', // $tertiary-green
  },
  pode_melhorar: {
    text: 'Dá pra melhorar',
    mainColor: '#e6ac00', // $secondary-darker-yellow
    backgroundColor: '#ffeac4', // $tertiary-yellow
  },
};

interface FeedbackCommentCardsProps {
  criteriaGrades: SimplifiedFeedbackData['criteriaGrades'];
}

function FeedbackCommentCards({
  criteriaGrades,
}: FeedbackCommentCardsProps): JSX.Element {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>O que a gente viu no seu texto</h2>

      <div className={styles.cards}>
        {CRITERIA_ORDER.map((criterion) => {
          const comment = getSimplifiedFeedbackComment(
            criterion,
            criteriaGrades[criterion],
          );

          if (!comment) return null;

          const sealTag = SEAL_TAG_PROPS[comment.seal];

          return (
            <div key={criterion} className={styles.card}>
              <span className={styles.cardIcon} aria-hidden="true">
                {CRITERION_EMOJI[criterion]}
              </span>

              <div className={styles.cardBody}>
                <span className={styles.sealTag}>
                  <Tag
                    variant="readOnly"
                    text={sealTag.text}
                    mainColor={sealTag.mainColor}
                    backgroundColor={sealTag.backgroundColor}
                  />
                </span>

                <h3 className={styles.title}>{comment.title}</h3>
                <p className={styles.comment}>{comment.comment}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FeedbackCommentCards;
